// extracted by mini-css-extract-plugin
export default {"del-icon-container":"DeleteButton_del-icon-container__LQylR","disabled-button":"DeleteButton_disabled-button__zFUIt"};